import React from "react"
import { TableHeaderColumn, TableRow, TableHeader, TableRowColumn, TableBody, FlatButton } from "material-ui"
import MaterialTable from "material-ui/Table"
import ImageLoader from "../../misc/ImageLoader"
import AddPunchDialog from "../../punch/AddPunchDialog"
import autobind from "class-autobind"
import AccountStore from "../../../stores/AccountStore"
import strings from "../../../localization/strings"
import { browserHistory } from "react-router"
import TimecardInnerTable from "./TimecardInnerTable"
import AuthenticationStore from "../../../stores/AuthenticationStore"
import moment from "moment"
import * as punchActions from "../../../actions/PunchActions"
import * as permissionHelper from "../../../helpers/permissionHelper"
import * as api from "../../../api"
import {
	IDate, IUIUser, ITimecardDay, IUserDocument, EPunchSetApprovalType, IPunchBundle,
	ECheckResultForRemovedPunchData, ITimecardFullData, IObjectTimecardDocument, IPayrollPayCalendar, IJobDocument
} from "../../../models"
import ApproveIcon from "../../../components/approve/ApproveIcon"
import * as ExceptionFilterActions from "../../../actions/ExceptionFilterActions"
import ExternalLink from "../../../components/common/externalLink/ExternalLink"
import * as userHelper from "../../../helpers/userHelper"
import AppStateStore from "../../../stores/AppStateStore"
import * as punchHelper from "../../../helpers/punchHelper"
import Table from "../../common/Table"
import * as timecardHelper from "../../../helpers/timecardHelper"
import * as userTimecardActions from "../../../actions/UserTimecardActions"

interface IProps {
	readonly?: boolean
	showCheckBox?: boolean
	timecards: ITimecardFullData[]
	payrollPayCalendar: IPayrollPayCalendar
	total: number
	offset: number
	limit: number
	limitOptions: number[]
	filterByPunchHierarchy?: boolean
	expandAllTimecards?: boolean
	onPageClick(offset: number): void
	onLimitChange(limit: number): void
	reLoadTimecards(cb?: () => void): void
	handleSelect?(selecedTimecards: ITimecardFullData[]): void
	handleApproveStatusForOneTimecard?(timecard: ITimecardFullData, status: string, dayOfWeekIndex: number): void
	allowPriorPeriodChange?: boolean

	// if Job->Timecard, it's not full timecard object. so let's hide Info icon to show Notes, Audits and WorkHistory.
	hideInfoIcon?: boolean
	showTimecardDetails: boolean

	// job -> timecard list
	job?: IJobDocument
}
interface IState {
	expandedTimecard: ITimecardFullData
	selectedTimecards: ITimecardFullData[]
	// for adding punch
	openPunchDialog: boolean
	punchTimecardDay: ITimecardDay
	editingUser: IUserDocument
	defaultAddPunchHierarchyId: string
	defaultAddPunchPositionId: string
	defaultAddPayClassId: string
	defaultAddPunchPayTypeId: string
	defaultShiftId: string
	defaultBreakId: string
	defaultMobileBreakId: string
	defaultAddJobId: string
	defaultPhaseId: string
	defaultEquipmentId: string
	defaultAddPunchPayrollHierarchyId: string
	defaultAddPunchPayrollPayGroupId: string
	isPunchIn: boolean
	pairedPunchId: string
	showTimecard: boolean
}

export default class TimecardsTable extends React.Component<IProps, IState> {
	constructor(props: IProps) {
		super(props)
		this.state = {
			expandedTimecard: null,
			selectedTimecards: [],
			openPunchDialog: false,
			punchTimecardDay: null,
			editingUser: null,
			defaultAddPunchHierarchyId: null,
			defaultAddPunchPositionId: null,
			defaultAddPayClassId: null,
			defaultAddPunchPayTypeId: null,
			defaultShiftId: null,
			defaultBreakId: null,
			defaultMobileBreakId: null,
			defaultAddJobId: null,
			defaultPhaseId: null,
			defaultEquipmentId: null,
			defaultAddPunchPayrollHierarchyId: null,
			defaultAddPunchPayrollPayGroupId: null,
			isPunchIn: false,
			pairedPunchId: null,
			showTimecard: true
		}
		autobind(this)
	}

	async addPunchToTimecardDay(timecardDay, user, timecard: IObjectTimecardDocument, hierarchyItemId, positionId, payClassId, payTypeId, shiftId, breakId, mobileBreakId, jobId, phaseId, equipmentId, isPunchIn, pairedPunchId) {

		let defaultPositionId
		if (positionId) {
			const positionExists = await api.getPositions(user.Id, hierarchyItemId, shiftId, jobId, phaseId).then(res =>
				res.data.find(item => item.Id === positionId))

			defaultPositionId = positionExists ? positionId : user.DefaultPositionId
		} else {
			defaultPositionId = positionId
			const result = await punchHelper.checkRemovedDataForPunch(user.Id, hierarchyItemId, shiftId, jobId, phaseId, positionId, true, user.DefaultPositionId === positionId)
			if (result !== ECheckResultForRemovedPunchData.Valid) return
		}
		for (let iter2 = 0; iter2 < timecard.MasterTimecard.TimecardWeeks.length; iter2++) {
			for (let iter3 = 0; iter3 < timecard.MasterTimecard.TimecardWeeks[iter2].Days.length; iter3++) {
				if (
					timecardDay.StartDayTime === timecard.MasterTimecard.TimecardWeeks[iter2].Days[iter3].StartDayTime &&
					timecardDay.EndDayTime === timecard.MasterTimecard.TimecardWeeks[iter2].Days[iter3].EndDayTime
				) {
					this.setState({
						punchTimecardDay: timecard.MasterTimecard.TimecardWeeks[iter2].Days[iter3],
						openPunchDialog: true,
						editingUser: user,
						defaultAddPunchHierarchyId: hierarchyItemId,
						defaultAddPunchPositionId: defaultPositionId,
						defaultAddPayClassId: payClassId,
						defaultAddPunchPayTypeId: payTypeId,
						defaultAddJobId: jobId,
						defaultShiftId: shiftId,
						defaultBreakId: breakId,
						defaultMobileBreakId: mobileBreakId,
						defaultPhaseId: phaseId,
						defaultEquipmentId: equipmentId,
						defaultAddPunchPayrollHierarchyId: timecard.PayrollHierarchyId,
						defaultAddPunchPayrollPayGroupId: timecard.PayrollPayGroupId,
						isPunchIn,
						pairedPunchId
					})
					break
				}
			}
		}
	}

	onTimeChange(userId: string, punchId: string, dateTime: IDate, errorCb: () => void) {
		const currTop = window.scrollY
		const currLeft = window.scrollX
		const partialPunch = {
			DateTime: moment(dateTime).utc().format()
		}
		punchActions.patchPunch(userId, punchId, partialPunch, false, null, this.props.allowPriorPeriodChange,
			() => {
				ExceptionFilterActions.refreshExceptionFilter()
				this.props.reLoadTimecards(() =>
					this.setState({ showTimecard: false }, () => {
						this.setState({ showTimecard: true }, () => window.scrollTo(currLeft, currTop))
					})
				)
			},
			errorCb
		)
	}

	onConfirmDelete(punchId: string, timecard: ITimecardFullData) {
		punchActions.deletePunchHandler(
			punchId,
			timecard.Timecard.MasterTimecard.FullPunchSets.find(ps => ps.PunchInId === punchId || ps.PunchOutId === punchId),
			false,
			() => {
				ExceptionFilterActions.refreshExceptionFilter()
				this.props.reLoadTimecards()
			}
		)
	}

	addPunch(userId: string, punchBundle: IPunchBundle) {
		this.setState({ openPunchDialog: false })
		punchActions.addPunch(userId, punchBundle, !this.state.isPunchIn,
			() => {
				ExceptionFilterActions.refreshExceptionFilter()
				this.props.reLoadTimecards()
			}
		)
	}

	onSummaryCellClick(rowNumber) {
		const clickedTimecard = this.props.timecards[rowNumber]
		this.setState({ expandedTimecard: clickedTimecard.Pending ? null : this.state.expandedTimecard && this.state.expandedTimecard.Timecard.Id === clickedTimecard.Timecard.Id ? null : clickedTimecard })
		const currTop = window.scrollY
		const currLeft = window.scrollX
		window.scrollTo(currLeft, currTop)
	}

	onClickEmployeeImgCol(e, userId: string) {
		e.stopPropagation()
		if (!permissionHelper.hasPermission(AuthenticationStore.Permissions.Employees.ViewEmployees)) return
		api.getUser(userId).then(res => {
			const user = res.data as IUserDocument
			user.Deleted ?
				AppStateStore.setProgressSnackbarContent(strings.This_employee_has_been_deleted) :
				browserHistory.push("/user-details/" + userId + "/timecards")
		})
	}

	render() {
		const showCheckBox = this.props.showCheckBox ? true : false
		let pendingRowColSpan = 2
		if (!this.props.filterByPunchHierarchy) {
			pendingRowColSpan += 3
			if (this.props.handleApproveStatusForOneTimecard) {
				if (AccountStore.getEmployeeApproveTimecardEnabled()) {
					pendingRowColSpan += 1
				}
				pendingRowColSpan += 1
			}
		}

		return (
			<div>
				<Table
					items={this.props.timecards}
					selectObjectName={"Timecard"}
					selectedItems={this.state.selectedTimecards}
					handleSelect={selectedTimecards => {
						this.props.handleSelect &&
							this.props.handleSelect(selectedTimecards)
						this.setState({ selectedTimecards })
					}}
					total={this.props.total}
					offset={this.props.offset}
					limit={this.props.limit}
					limitOptions={this.props.limitOptions}
					onPageClick={this.props.onPageClick}
					onLimitChange={this.props.onLimitChange}
				>
					<TableHeader displaySelectAll={showCheckBox} adjustForCheckbox={showCheckBox} enableSelectAll={true}>
						<TableRow>
							<TableHeaderColumn style={{ width: 25, paddingLeft: 5, paddingRight: 5 }} />
							<TableHeaderColumn style={{ width: 30 }} />
							<TableHeaderColumn style={styles.columnValueHeader}>{strings.Employee}</TableHeaderColumn>
							<TableHeaderColumn style={styles.columnValueHeader}>{strings.TotalHours}</TableHeaderColumn>
							<TableHeaderColumn style={styles.columnValueHeader}>{strings.WorkingTotalHours}</TableHeaderColumn>
							{!this.props.filterByPunchHierarchy && [
								<TableHeaderColumn style={styles.columnValueHeader} key="Reg">{strings.RegularHours}</TableHeaderColumn>,
								<TableHeaderColumn style={styles.columnValueHeader} key="OT">{strings.OvertimeHours}</TableHeaderColumn>,
								!AccountStore.getHideOT2() &&
								<TableHeaderColumn style={styles.columnValueHeader} key="OT2">{strings.DoubleOvertimeHours}</TableHeaderColumn>,
							]}
							<TableHeaderColumn style={styles.columnValueHeader}>{strings.Open_Punches}</TableHeaderColumn>
							{!this.props.filterByPunchHierarchy && this.props.handleApproveStatusForOneTimecard && [
								AccountStore.getEmployeeApproveTimecardEnabled() &&
								<TableHeaderColumn style={styles.columnValueHeader} key="EmpApprove">{strings.Employee}</TableHeaderColumn>,
								<TableHeaderColumn style={styles.columnValueHeader} key="SupApprove">{strings.Supervisor}</TableHeaderColumn>,
								AccountStore.getExtSupApproveTimecardEnabled() &&
								<TableHeaderColumn style={styles.columnValueHeader} key="ExtSupApprove">{strings.External}</TableHeaderColumn>,
							]}
						</TableRow>
					</TableHeader>
					<TableBody showRowHover={false} deselectOnClickaway={false} displayRowCheckbox={showCheckBox}>
						{this.props.timecards.map((row, index) => {
							const expanded = this.state.expandedTimecard && this.state.expandedTimecard.Timecard.Id === row.Timecard.Id
							const selected = this.state.selectedTimecards.find(item => item.Timecard.Id === row.Timecard.Id) !== undefined
							const colValStyle = { ...styles.columnValue, fontWeight: !row.Pending && row.Timecard.TotalMissingPunches > 0 && "bold" }
							const timecardWeek = row.Timecard && row.Timecard.MasterTimecard.TimecardWeeks && row.Timecard.MasterTimecard.TimecardWeeks.length > 0 ?
								row.Timecard.MasterTimecard.TimecardWeeks[0] :
								null
							return (
								<TableRow data-intercom-target={index === 0 && "menu-Timecards-openItemDetails"} key={index} className="TimecardsTable" selected={selected}>
									<TableRowColumn style={styles.columnValue}>
										<MaterialTable selectable={false} onCellClick={() => this.onSummaryCellClick(index)}>
											<TableBody displayRowCheckbox={false}>
												<TableRow
													style={{
														borderBottom: (expanded && !this.props.expandAllTimecards) && "solid 2px #cccccc",
														background: selected && "rgb(224, 224, 224)"
													}}
												>
													<TableRowColumn data-intercom-target={index === 0 && "menu-Timecards-openEmployeeDetailsInNewTab"} style={{ width: 25, paddingLeft: 5, paddingRight: 5, paddingTop: 4 }}>
														<div
															onClick={() => userTimecardActions.handleChangeReferenceDate(row.Timecard.StartDate)}
														>
															<ExternalLink
																url={"/user-details/" + row.Timecard.Employee.Id + "/" + userHelper.getValidSubPages()[0]}
															/>
														</div>
													</TableRowColumn>
													<TableRowColumn style={{ width: 30 }}>
														{row.Timecard.Employee.ProfileImageS3Url &&
															<div
																onClick={e => this.onClickEmployeeImgCol(e, row.Timecard.Employee.Id)}
																style={{ cursor: "pointer" }}
															>
																<ImageLoader url={row.Timecard.Employee.ProfileImageS3Url} fixedHeight={75} avatar={true} src={"/users/profileimage/" + row.Timecard.Employee.ProfileImageID} />
															</div>
														}
													</TableRowColumn>
													<TableRowColumn style={{ ...colValStyle, verticalAlign: "bottom" }}>
														{row.Timecard.Employee.FirstName + " " + row.Timecard.Employee.LastName}
														<br></br>
														<span style={{ color: "rgb(158, 158, 158)", fontSize: 10 }}>Emp #: {row.Timecard.Employee.ExternalId}</span>
													</TableRowColumn>
													{row.Pending ?
														<TableRowColumn style={styles.columnValue} colSpan={pendingRowColSpan}>
															<div style={{ display: "flex", alignItems: "center", justifyContent: "space-around" }}>
																<span>{strings.There_has_been_changes_made_to_the_punches_in_this_timecard_that_require_it_to_be_regenerated}</span>
																<FlatButton
																	label={strings.Generate}
																	backgroundColor={AppStateStore.getFrontEndSettings().UISettings.AccentColor}
																	hoverColor={AppStateStore.getFrontEndSettings().UISettings.AccentColor}
																	labelStyle={{ color: "white" }}
																	onClick={async () => {
																		AppStateStore.setTextProgressSnackbarContent({ progressText: strings.Generate_Timecard })
																		await api.generateUserTimecard(row.Timecard.Employee.Id)
																		this.props.reLoadTimecards(() => AppStateStore.setTextProgressSnackbarContent(null))
																	}}
																/>
															</div>
														</TableRowColumn> :
														[
															<TableRowColumn key="totalduration" style={colValStyle}>
																{timecardWeek ?
																	timecardWeek.TimeTotals.TotalHours :
																	0 +
																	" hrs"
																}
															</TableRowColumn>,
															<TableRowColumn key="totalduration" style={colValStyle}>
																{timecardWeek ?
																	timecardWeek.TimeTotals.TotalProductiveHours :
																	0 +
																	" hrs"
																}
															</TableRowColumn>,
															!this.props.filterByPunchHierarchy && [
																<TableRowColumn style={colValStyle} key="Reg">{timecardWeek ? timecardWeek.TimeTotals.RegularHours : 0 + " hrs"}</TableRowColumn>,
																<TableRowColumn style={colValStyle} key="OT">{timecardWeek ? timecardWeek.TimeTotals.OvertimeHours : 0 + " hrs"}</TableRowColumn>,
																!AccountStore.getHideOT2() &&
																<TableRowColumn style={colValStyle} key="OT2">{timecardWeek ? timecardWeek.TimeTotals.DoubleOvertimeHours : 0 + " hrs"}</TableRowColumn>
															],
															<TableRowColumn key="missingpunches" style={colValStyle}>{row.Timecard.TotalMissingPunches}</TableRowColumn>,
															!this.props.filterByPunchHierarchy && this.props.handleApproveStatusForOneTimecard && [
																AccountStore.getEmployeeApproveTimecardEnabled() &&
																<TableRowColumn style={styles.columnValue} key="EmpApprove">
																	<ApproveIcon
																		identify={`weekemployeeapprove${index}`}
																		toolTipPosition="bottom"
																		toolTipArrow="center"
																		width={16}
																		approvalType={EPunchSetApprovalType.Employee}
																		punchSets={row.Timecard.MasterTimecard.FullPunchSets}
																		expenses={timecardHelper.getTimecardAllExpenses(row.Timecard.MasterTimecard)}
																	/>
																</TableRowColumn>,
																< TableRowColumn style={styles.columnValue} key="SupApprove">
																	<ApproveIcon
																		identify={`weeksupervisorapprove${index}`}
																		toolTipPosition="bottom"
																		toolTipArrow="center"
																		width={16}
																		approvalType={EPunchSetApprovalType.Supervisor}
																		punchSets={row.Timecard.MasterTimecard.FullPunchSets}
																		expenses={timecardHelper.getTimecardAllExpenses(row.Timecard.MasterTimecard)}
																		handleApproveStatus={this.props.handleApproveStatusForOneTimecard ?
																			status => this.props.handleApproveStatusForOneTimecard(row, status, -1) :
																			null
																		}
																		locked={timecardHelper.timecardPartialLocked(row.Timecard.ObjectId, row.Timecard.StartDate, row.Timecard.EndDate, row.PayrollStatus, EPunchSetApprovalType.Supervisor)}
																	/>
																</TableRowColumn>,
																AccountStore.getExtSupApproveTimecardEnabled() &&
																<TableRowColumn style={styles.columnValue} key="ExtSupApprove">
																	<ApproveIcon
																		identify={`weekextsupapprove${index}`}
																		toolTipPosition="bottom"
																		toolTipArrow="center"
																		width={16}
																		approvalType={EPunchSetApprovalType.ExtSupervisor}
																		punchSets={row.Timecard.MasterTimecard.FullPunchSets}
																		expenses={[]}
																	/>
																</TableRowColumn>
															]
														]
													}
												</TableRow>
												{((this.state.expandedTimecard && this.state.expandedTimecard.Timecard && this.state.expandedTimecard.Timecard.Id === row.Timecard.Id) || (this.props.expandAllTimecards)) &&
													<TableRow key={row.Timecard.Id + "-1"}>
														<TableRowColumn
															colSpan={this.props.filterByPunchHierarchy ?
																6 :
																(
																	8 +
																	(this.props.handleApproveStatusForOneTimecard ? (AccountStore.getEmployeeApproveTimecardEnabled() ? 2 : 1) : 0) +
																	(AccountStore.getHideOT2() ? 0 : 1) +
																	(AccountStore.getExtSupApproveTimecardEnabled() ? 1 : 0)
																)
															}
														>
															<div onClick={(e) => e.stopPropagation()}>
																<TimecardInnerTable
																	showTimcard={this.state.showTimecard}
																	dailyNoteDates={row.DailyNoteDates}
																	timecard={row}
																	employee={row.Timecard.Employee}
																	payrollPayCalendar={this.props.payrollPayCalendar}
																	handleApproveStatus={this.props.handleApproveStatusForOneTimecard}
																	onAddPunchToTimecardDay={this.addPunchToTimecardDay}
																	onTimeChange={(punchId: string, dateTime: IDate, errorCb: () => void) => this.onTimeChange(row.Timecard.Employee ? row.Timecard.Employee.Id : null, punchId, dateTime, errorCb)}
																	onConfirmDelete={this.onConfirmDelete}
																	readonly={this.props.readonly}
																	key={index}
																	reloadTimecard={this.props.reLoadTimecards}
																	filterByPunchHierarchy={this.props.filterByPunchHierarchy}
																	hideInfoIcon={this.props.hideInfoIcon}
																	showTimecardDetails={this.props.showTimecardDetails}
																	job={this.props.job}
																/>
															</div>
														</TableRowColumn>
													</TableRow>
												}
											</TableBody>
										</MaterialTable>
									</TableRowColumn>
								</TableRow>
							)
						})}
					</TableBody>
				</Table>
				{this.state.openPunchDialog &&
					<AddPunchDialog
						date={this.state.punchTimecardDay.LocalStartDayTime}
						user={this.state.editingUser as IUIUser}
						onRequestClose={() => this.setState({ openPunchDialog: false })}
						addPunch={this.addPunch}
						hierarchyId={this.props.job ? this.props.job.HierarchyId : this.state.defaultAddPunchHierarchyId}
						positionId={this.state.defaultAddPunchPositionId}
						payClassId={this.state.defaultAddPayClassId}
						payTypeId={this.state.defaultAddPunchPayTypeId}
						jobId={this.props.job ? this.props.job.Id : this.state.defaultAddJobId}
						shiftId={this.state.defaultShiftId}
						breakId={this.state.defaultBreakId}
						mobileBreakId={this.state.defaultMobileBreakId}
						phaseId={this.state.defaultPhaseId}
						equipmentId={this.state.defaultEquipmentId}
						isPunchIn={this.state.isPunchIn}
						pairedPunchId={this.state.pairedPunchId}
						payrollHierarchyId={this.state.defaultAddPunchPayrollHierarchyId}
						payrollPayGroupId={this.state.defaultAddPunchPayrollPayGroupId}
					/>
				}
			</div >
		)
	}
}

const styles = {
	read: {
		fontWeight: "normal",
		cursor: "pointer"
	},
	columnValue: {
		paddingLeft: 0,
		paddingRight: 0,
		padding: 0,
		textAlign: "center",
		cursor: "pointer",
		whitespace: "normal"
	},
	columnValueHeader: {
		paddingLeft: 0,
		paddingRight: 0,
		textAlign: "center",
		cursor: "pointer",
		whitespace: "normal"
	},
	columnValueCenterExpandable: {
		textAlign: "center",
		cursor: "pointer",
		width: "100%"
	},
	bodyStyle: {
		height: "calc(80vh - 400px)",
		overflowY: "visible"
	}
}
